import React from 'react';

const facilities = () => {
  return (
    <div>
      facilities
    </div>
  );
}

export default facilities;
